import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from "@angular/core";

@Component({
	selector: "bp-extended-tooltip",
	templateUrl: "./bp-extended-tooltip.component.html",
	styleUrls: ["./bp-extended-tooltip.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	exportAs: "bpExtendedTooltip",
	standalone: false
})
export class BpExtendedTooltipComponent {
	// @Input() tooltipVisible: boolean = false;
	@Input() tooltip: string = "";
	@Input() actionButtonName: string = "";
	@Input() top: number = 0;
	@Input() left: number = 0;
	@Output() onActionButtonClicked = new EventEmitter<void>();
	@Output() onMouseEnter = new EventEmitter<void>();
	@Output() onMouseLeave = new EventEmitter<void>();
}
